// extracted by mini-css-extract-plugin
export var currencyInput = "_je-1";
export var currencySymbol = "_je-0";